import { MessageDescriptor } from 'react-intl';
import styled from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import OnboardingNavButtons from '../../Components/OnboardingNavButtons';

export const H1Wrapper = styled.h1`
	display: flex;
	outline: none;
`;

export const Content = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	text-align: center;
	height: 100%;
	justify-content: space-between;
	padding-top: 32px;
	background: ${palette('gradientCalmBrandDark')};
`;

export const Title = styled.h4`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Medium)};
	margin-top: 32px;
	margin-bottom: 16px;

	${minWidth('desktop')} {
		color: ${palette('white')};
	}
`;

export const Description = styled.div`
	color: ${palette('gray7')};
	margin-bottom: 32px;

	${minWidth('desktop')} {
		color: ${palette('white')};
	}
`;

export const RecommendationTitle = styled.p`
	margin-top: 6px;
	${fontWeight(FontWeights.Demi)};
	font-size: 14px;
`;

export const RecommendationSubTitle = styled.p`
	font-size: 13px;
	margin-bottom: 16px;
`;

export const Logo = styled.img`
	height: auto;
	margin-left: 8px;
	position: relative;
	top: 2px;
	width: 72px;
`;

export const OnboardingImageWrapper = styled.div`
	img {
		border-radius: 20px;
		overflow: hidden;
	}
`;

export const OnboardingImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;

	> :first-child img {
		border-top-left-radius: 0px;
		border-bottom-left-radius: 0px;
	}

	> :last-child img {
		border-top-right-radius: 0px;
		border-bottom-right-radius: 0px;
	}

	${minWidth('desktop')} {
		padding: 0 30px;
	}
`;

export const RecBackground = styled.div`
	background: ${palette('gradientCalmBrandDark')};
`;

export const DesktopDeviceContainer = styled.div<{
	skippedFTUE: boolean;
}>`
	width: ${ifProp('skippedFTUE', '100%')};

	${minWidth('desktop')} {
		background: url('/_n/images/jayshetty/device-bg.webp');
		background-size: cover;
		background-position: center top;
		width: 424px;
		padding-top: 130px;
		margin-bottom: -28px;
		margin-top: 30px;
		max-height: 700px;
		flex: 3;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
	}
`;

export const QRCodeInstructions = styled(Description)`
	color: ${palette('gray7')};
	display: none;
	${minWidth('desktop')} {
		display: block;
	}
`;

export const QRCodeWrapper = styled.div`
	display: none;
	${minWidth('desktop')} {
		display: block;
	}
`;

export const OnboardingNavButtonHandoff = styled(OnboardingNavButtons)<{
	skippedFTUE: boolean;
	continueCta: MessageDescriptor;
}>`
	${minWidth('desktop')} {
		display: none;
	}
	margin-bottom: ${ifProp('skippedFTUE', '0', '80px')};
	margin-top: ${ifProp('skippedFTUE', '80px', 'auto')};
	padding: ${ifProp('skippedFTUE', '20px')};
`;
